import { useCallback, useEffect, useRef, useState } from 'react';

import classes from 'components/common/PageBreadcrumbs/components/BreadcrumbLabel.module.scss';

import { Tooltip } from 'components/DesignSystem/Tooltip';

interface BreadcrumbLabelProps {
    label: string;
    isLastBreadCrumb?: boolean;
    noEllipsis?: boolean;
}

export const BreadcrumbLabel = ({ label, isLastBreadCrumb, noEllipsis }: BreadcrumbLabelProps) => {
    const labelRef = useRef<HTMLSpanElement>(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    const checkOverflow = useCallback(() => {
        if (labelRef.current) {
            setIsOverflowing(labelRef.current.scrollWidth > labelRef.current.clientWidth);
        }
    }, []);

    useEffect(() => {
        checkOverflow();
        window.addEventListener('resize', checkOverflow);
        return () => window.removeEventListener('resize', checkOverflow);
    }, [checkOverflow, label]);

    const labelElement = (
        <span
            ref={labelRef}
            className={`${classes.label} ${isLastBreadCrumb ? classes.active : ''} ${noEllipsis ? classes.noEllipsis : ''}`}
        >
            {label}
        </span>
    );

    if (isOverflowing) {
        return <Tooltip content={label}>{labelElement}</Tooltip>;
    }

    return labelElement;
};
